import { render, staticRenderFns } from "./messages.vue?vue&type=template&id=1c0bb948&scoped=true"
import script from "./messages.vue?vue&type=script&lang=js"
export * from "./messages.vue?vue&type=script&lang=js"
import style0 from "./messages.vue?vue&type=style&index=0&id=1c0bb948&prod&scoped=true&lang=css"
import style1 from "./messages.vue?vue&type=style&index=1&id=1c0bb948&prod&lang=css"
import style2 from "./messages.vue?vue&type=style&index=2&id=1c0bb948&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0bb948",
  null
  
)

export default component.exports